import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bookedHotel: [],
  hotelinfo: "",
};

export const bookedReducer = createSlice({
  name: "booked",
  initialState,
  reducers: {
    setHotelBook: (state, action) => {
      state.bookedHotel = action.payload;
    },
    setHotelinfo: (state, action) => {
      state.hotelinfo = action.payload;
    },
  },
});

export const { setHotelBook, setHotelinfo } = bookedReducer.actions;
export default bookedReducer.reducer;
